import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsFilterWertAusp extends GlobalConstantsTableCols {
   
  public static getColumns(): string[] {
  
      return [
        GlobalConstantsTableCols.COMBOBOX,
        GlobalConstantsTableCols.WERT
      ];
  
  }
}


